export function getStatus(honorariosMeses = []) {
  const media =
    honorariosMeses.length === 0
      ? 0
      : honorariosMeses.reduce((a, b) => a + b, 0) / honorariosMeses.length;

  if (media >= 50000)
    return {
      nivel: 'Operador de Mercado',
      media,
      mensagem:
        'Você opera como empresa. O desafio agora é escalar com controle.',
    };

  if (media >= 25000)
    return {
      nivel: 'Alta Performance',
      media,
      mensagem:
        'Você domina o jogo e inspira. Isso não é elogio, é leitura de cenário.',
    };

  if (media >= 12000)
    return {
      nivel: 'Corretor Profissional',
      media,
      mensagem:
        'Você vive da corretagem. O próximo nível exige inteligência de dados.',
    };

  if (media >= 5000)
    return {
      nivel: 'Corretor em Consolidação',
      media,
      mensagem: 'Você já sabe vender. Agora precisa criar previsibilidade.',
    };

  return {
    nivel: 'Corretor Iniciante',
    media,
    mensagem:
      'Você está construindo base. O foco agora é método e consistência.',
  };
}
